import { render } from "./MdCardHeaderText.vue?vue&type=template&id=19e2a001"
import script from "./MdCardHeaderText.vue?vue&type=script&lang=js"
export * from "./MdCardHeaderText.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__